// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const Tstimonialshow = ({ typedHeading = '', typedQuote = '' }) => {
//   const [studentAchievements, setStudentAchievements] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   const BASE_URL = ""; // ✅ Your backend server address

// useEffect(() => {
//   axios.get(`${BASE_URL}/api/achievements`)
//     .then(res => {
//       if (Array.isArray(res.data)) {
//         setStudentAchievements(res.data);
//       } else {
//         console.error("Expected array but got:", res.data);
//         setStudentAchievements([]);
//       }
//     })
//     .catch(err => console.error('Error fetching achievements', err));

//   axios.get(`${BASE_URL}/api/testimonials`)
//     .then(res => {
//       if (Array.isArray(res.data)) {
//         setTestimonials(res.data);
//       } else {
//         console.error("Expected array but got:", res.data);
//         setTestimonials([]);
//       }
//     })
//     .catch(err => console.error('Error fetching testimonials', err));
// }, []);


//   return (
//    <section
//   style={{
//     display: "flex",
//     flexDirection: "column", // ✅ Always top-to-bottom
//     justifyContent: "flex-start",
//     alignItems: "center",
//     gap: "20px",
//     padding: "20px",
//     background: "#f4f4f4",
//     fontFamily: "Arial, sans-serif"
//   }}
// >
//    <div style={{
//         backgroundColor: "#fff",
//         border: "1px solid #ddd",
//         borderRadius: "10px",
//         padding: "20px",
//         width: "100%",
//         maxWidth: "400px",
//         margin: "auto",
//       }}>
//         <h6 style={{
//           fontSize: "20px",
//           fontWeight: "bold",
//           marginBottom: "15px",
//           textAlign: "center"
//         }}>
//           Testimonial
//         </h6>
//         <div style={{
//           height: "420px",
//           overflow: "hidden",
//           position: "relative",
//           borderRadius: "8px",
//           border: "2px solid #eee",
//         }}>
//           <div style={{
//             display: "flex",
//             flexDirection: "column",
//             animation: "scrollDown 25s linear infinite",
//           }}>
//             {testimonials.map((event, i) => (
//               <div key={i} style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 backgroundColor: "#f8f8f8",
//                 padding: "10px",
//                 borderRadius: "8px",
//                 marginBottom: "12px",
//               }}>
//                 <img
//                   src={`${BASE_URL}${event.img}`}
//                   alt={event.name}
//                   style={{
//                     width: "60px",
//                     height: "60px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ccc",
//                   }}
//                 />
//                 <div style={{ flexGrow: 1 }}>
//                   <div style={{ fontSize: "15px", fontWeight: "bold", color: "#000" }}>{event.name}</div>
//                   <div style={{ fontSize: "13px", color: "#555" }}>{event.company}</div>
//                   <div style={{ fontSize: "12px", color: "#777", marginTop: "4px" }}>{event.desc}</div>
//                 </div>
//                 <div style={{
//                   backgroundColor: "#ff0046",
//                   color: "#fff",
//                   padding: "6px",
//                   borderRadius: "6px",
//                   textAlign: "center",
//                   minWidth: "50px",
//                 }}>
//                   <div style={{ fontSize: "11px", fontWeight: "bold" }}>{event.month}</div>
//                   <div style={{ fontSize: "16px", fontWeight: "bold" }}>{event.day}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>


//       {/* Left Box – Student Achievements */}
//       <div style={{
//         backgroundColor: "#fff",
//         border: "1px solid #ddd",
//         borderRadius: "10px",
//         padding: "20px",
//         width: "100%",
//         maxWidth: "400px",
//         margin: "auto",
//       }}>
//         <h6 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "15px", textAlign: "center" }}>
//           Student's Achievements
//         </h6>
//         <div style={{
//           height: "400px",
//           overflow: "hidden",
//           position: "relative",
//           borderRadius: "8px",
//           border: "2px solid #eee",
//         }}>
//           <div style={{
//             display: "flex",
//             flexDirection: "column",
//             animation: "scrollUp 20s linear infinite",
//           }}>
//             {studentAchievements.map((student, i) => (
//               <div key={i} style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 marginBottom: "12px",
//                 padding: "10px",
//               }}>
//                 <img
//                   src={`${BASE_URL}${student.img}`}
//                   alt={student.title}
//                   style={{
//                     width: "100%",
//                     height: "250px",
//                     objectFit: "cover",
//                     borderRadius: "8px",
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//                     marginBottom: "10px"
//                   }}
//                 />
//                 <div style={{
//                   fontSize: "14px",
//                   color: "#333",
//                   textAlign: "center",
//                   fontWeight: "500",
//                 }}>
//                   {student.title}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Center Box – SAP Details */}
  


//       {/* Right Box – Testimonials */}
     

//       {/* Animations */}
//       <style>
//         {`
//           @keyframes scrollUp {
//             0% { transform: translateY(0); }
//             100% { transform: translateY(-40%); }
//           }
//           @keyframes scrollDown {
//             0% { transform: translateY(-100%); }
//             100% { transform: translateY(0); }
//           }
//         `}
//       </style>
      
//     </section>
//   );
// };

// export default Tstimonialshow;


// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';

// const Tstimonialshow = () => {
//   const [studentAchievements, setStudentAchievements] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);
//   const BASE_URL = "";

//   const testimonialRef = useRef(null);
//   const achievementRef = useRef(null);

//   useEffect(() => {
//     axios.get(`${BASE_URL}/api/achievements`)
//       .then(res => setStudentAchievements(Array.isArray(res.data) ? res.data : []))
//       .catch(err => console.error('Error fetching achievements', err));

//     axios.get(`${BASE_URL}/api/testimonials`)
//       .then(res => setTestimonials(Array.isArray(res.data) ? res.data : []))
//       .catch(err => console.error('Error fetching testimonials', err));
//   }, []);

//   const scrollLeft = (ref) => {
//     if (ref.current) {
//       ref.current.scrollBy({ left: -300, behavior: "smooth" });
//     }
//   };

//   const scrollRight = (ref) => {
//     if (ref.current) {
//       ref.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   return (
//     <section style={{
//       width: "100%",
//       padding: "20px",
//       fontFamily: "Arial, sans-serif",
//     }}>

//       {/* --- Testimonials Row --- */}
//       <h2 style={{ marginBottom: "10px",color:"orangered" }}>Our Team</h2>
//       <div style={{ position: "relative", marginBottom: "80px" }}>
//   <div
//     ref={testimonialRef}
//     style={{
//       overflowX: "auto",
//       whiteSpace: "nowrap",
//       scrollBehavior: "smooth"
//     }}
//   >
//     {testimonials.map((t, i) => (
//       <div key={i} style={{
//         display: "inline-block",
//         borderRadius: "8px",
//         marginRight: "15px",
//         padding: "10px",
//         minWidth: "250px",
//         textAlign: "center",
//         verticalAlign: "top"
//       }}>
//         <img
//           src={`${BASE_URL}${t.img}`}
//           alt={t.name}
//           style={{
//             width: "120px",
//             height: "120px",
//             borderRadius: "50%",
//             objectFit: "cover",
//             marginBottom: "10px"
//           }}
//         />
//         <div style={{ fontSize: "16px", fontWeight: "bold" }}>{t.name}</div>
//         <div style={{ fontSize: "14px", color: "#555" }}>{t.company}</div>
//         <div style={{ fontSize: "13px", color: "#777", marginTop: "6px" }}>{t.desc}</div>
//       </div>
//     ))}
//   </div>

//   {/* ✅ Buttons floating in the middle now */}
//   <button
//     onClick={() => scrollLeft(testimonialRef)}
//     style={buttonStyle("left")}
//   >
//     &#10094;
//   </button>
//   <button
//     onClick={() => scrollRight(testimonialRef)}
//     style={buttonStyle("right")}
//   >
//     &#10095;
//   </button>
// </div>


//       {/* --- Achievements Row (Logos) --- */}
//      <h2 style={{ marginBottom: "10px", color: "orangered" }}>Our Esteemed Customers</h2>
// <div style={{ position: "relative", marginBottom: "80px" }}>
//   <div
//     ref={achievementRef}
//     style={{
//       overflowX: "auto",
//       whiteSpace: "nowrap",
//       scrollBehavior: "smooth"
//     }}
//   >
//     {studentAchievements.map((a, i) => (
//       <div
//         key={i}
//         style={{
//           display: "inline-block",
//           borderRadius: "8px",
//           marginRight: "15px",
//           padding: "10px",
//           minWidth: "200px",
//           textAlign: "center",
//           verticalAlign: "top"
//         }}
//       >
//         <img
//           src={`${BASE_URL}${a.img}`}
//           alt={a.title}
//           style={{
//             width: "150px",
//             height: "150px",
//             objectFit: "contain",
//             borderRadius: "6px",
//             background: "#fff",
//             padding: "10px",
//             boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
//           }}
//         />
//       </div>
//     ))}
//   </div>

//   {/* ✅ Centered Arrow Buttons */}
//   <button
//     onClick={() => scrollLeft(achievementRef)}
//     style={buttonStyle("left")}
//   >
//     &#10094;
//   </button>
//   <button
//     onClick={() => scrollRight(achievementRef)}
//     style={buttonStyle("right")}
//   >
//     &#10095;
//   </button>
// </div>

//     </section>
//   );
// };

// // Button Styling Function
// const buttonStyle = (position) => ({
//   position: "absolute",
//   top: "50%",                     // center vertically
//   [position]: "10px",             // left or right
//   transform: "translateY(-50%)",  // adjust for perfect middle
//   background: "rgba(0,0,0,0.6)",
//   color: "#fff",
//   border: "none",
//   padding: "12px",
//   cursor: "pointer",
//   borderRadius: "50%",
//   fontSize: "20px",
//   boxShadow: "0 2px 6px rgba(113,111,111,0.2)",
//   zIndex: 10                      // ensure above content
// });


// export default Tstimonialshow;



import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const Tstimonialshow = () => {
  const [studentAchievements, setStudentAchievements] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const BASE_URL = "";

  const testimonialRef = useRef(null);
  const achievementRef = useRef(null);

  useEffect(() => {
    axios.get(`${BASE_URL}/api/achievements`)
      .then(res => setStudentAchievements(Array.isArray(res.data) ? res.data : []))
      .catch(err => console.error('Error fetching achievements', err));

    axios.get(`${BASE_URL}/api/testimonials`)
      .then(res => setTestimonials(Array.isArray(res.data) ? res.data : []))
      .catch(err => console.error('Error fetching testimonials', err));
  }, []);

  const scrollLeft = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <section style={{
      width: "100%",
      padding: "80px 20px",
      fontFamily: "'Poppins', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)",
      position: "relative"
    }}>

      {/* --- Testimonials Section --- */}
      <div style={{
        maxWidth: "1400px",
        margin: "0 auto",
        marginBottom: "100px",
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: "60px",
          position: "relative"
        }}>
          <div style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#2563eb",
            textTransform: "uppercase",
            letterSpacing: "2px",
            marginBottom: "15px"
          }}>
            Meet Our
          </div>
          <h2 style={{ 
            color: "orangered",
            fontSize: "3.2rem",
            fontWeight: "300",
            letterSpacing: "-1.5px",
            margin: "0",
            position: "relative",
            display: "inline-block"
          }}>
            Ramesh Enterprises Team
            <div style={{
              position: "absolute",
              bottom: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "120px",
              height: "3px",
             
              borderRadius: "3px"
            }}></div>
          </h2>
        </div>
        
        <div style={{ position: "relative" }}>
          <div
            ref={testimonialRef}
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollBehavior: "smooth",
              padding: "40px 80px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {testimonials.map((t, i) => (
              <div key={i} style={{
                display: "inline-block",
                borderRadius: "2px",
                marginRight: "40px",
                padding: "50px 35px",
                minWidth: "320px",
                maxWidth: "320px",
                textAlign: "center",
                verticalAlign: "top",
                background: "linear-gradient(145deg, #ffffff, #f8fafc)",
                border: "1px solid #e1e7ef",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-8px)";
                e.target.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.08)";
                e.target.style.borderColor = "#cbd5e0";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
                e.target.style.borderColor = "#e2e8f0";
              }}>
                
                {/* Subtle top accent */}
                <div style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  height: "2px",
                  background: "linear-gradient(90deg, orangered, #8b5cf6)",
                }}></div>
                
                <div style={{
                  marginBottom: "30px",
                  position: "relative"
                }}>
                  <img
                    src={`${BASE_URL}${t.img}`}
                    alt={t.name}
                    style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "4px solid #e0f2fe",
                      transition: "all 0.3s ease"
                    }}
                  />
                </div>
                
                <div style={{ 
                  fontSize: "22px", 
                  fontWeight: "600",
                  color: "#1e40af",
                  marginBottom: "12px",
                  letterSpacing: "-0.3px"
                }}>{t.name}</div>
                
                <div style={{ 
                  fontSize: "14px", 
                  color: "#dc2626",
                  fontWeight: "500",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                  letterSpacing: "1px"
                }}>{t.company}</div>
                
                <div style={{ 
                  fontSize: "15px", 
                  color: "#4a5568",
                  lineHeight: "1.7",
                  fontStyle: "italic",
                  position: "relative"
                }}>
                  <span style={{
                    fontSize: "40px",
                    color: "#e2e8f0",
                    position: "absolute",
                    top: "-20px",
                    left: "-10px",
                    fontFamily: "Georgia, serif"
                  }}>"</span>
                  {t.desc}
                  <span style={{
                    fontSize: "40px",
                    color: "#e2e8f0",
                    position: "absolute",
                    bottom: "-35px",
                    right: "-10px",
                    fontFamily: "Georgia, serif"
                  }}>"</span>
                </div>
              </div>
            ))}
          </div>

          {/* Modern Navigation Buttons */}
          <button
            onClick={() => scrollLeft(testimonialRef)}
            style={modernButtonStyle("left")}
            onMouseEnter={(e) => {
              e.target.style.background = "#1e40af";
              e.target.style.borderColor = "#1e40af";
              e.target.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ffffff, #f8fafc)";
              e.target.style.borderColor = "#cbd5e0";
              e.target.style.color = "#2563eb";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m15 18-6-6 6-6"/>
            </svg>
          </button>
          <button
            onClick={() => scrollRight(testimonialRef)}
            style={modernButtonStyle("right")}
            onMouseEnter={(e) => {
              e.target.style.background = "#1e40af";
              e.target.style.borderColor = "#1e40af";
              e.target.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ffffff, #f8fafc)";
              e.target.style.borderColor = "#cbd5e0";
              e.target.style.color = "#2563eb";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m9 18 6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>

      {/* --- Achievements Section --- */}
      <div style={{
        maxWidth: "1400px",
        margin: "0 auto",
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: "60px",
          position: "relative"
        }}>
          <div style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#2563eb",
            textTransform: "uppercase",
            letterSpacing: "2px",
            marginBottom: "15px"
          }}>
            Trusted By
          </div>
          <h2 style={{ 
            color: "orangered",
            fontSize: "3.2rem",
            fontWeight: "300",
            letterSpacing: "-1.5px",
            margin: "0",
            position: "relative",
            display: "inline-block"
          }}>
            Our estimated customer
            <div style={{
              position: "absolute",
              bottom: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "120px",
              height: "3px",
              
              borderRadius: "3px"
            }}></div>
          </h2>
        </div>
        
        <div style={{ position: "relative" }}>
          <div
            ref={achievementRef}
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollBehavior: "smooth",
              padding: "40px 80px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
{studentAchievements.map((a, i) => (
  <div
    key={i}
    style={{
      display: "inline-block",
      borderRadius: "2px",
      marginRight: "40px",
      padding: "40px 30px",
      minWidth: "250px",
      maxWidth: "250px",
      textAlign: "center",
      verticalAlign: "top",
      background: "linear-gradient(145deg, #ffffff, #f8fafc)",
      border: "1px solid #e1e7ef",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      position: "relative"
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = "translateY(-5px)";
      e.target.style.boxShadow = "0 15px 30px rgba(0, 0, 0, 0.06)";
      e.target.style.borderColor = "#cbd5e0";
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = "translateY(0)";
      e.target.style.boxShadow = "none";
      e.target.style.borderColor = "#e2e8f0";
    }}
  >
    {/* Company/Customer Name ABOVE logo */}
    <div style={{
      marginBottom: "15px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#1e293b",
      letterSpacing: "0.3px"
    }}>
      {a.title}
    </div>

    {/* Logo */}
    <img
      src={`${BASE_URL}${a.img}`}
      alt={a.title}
      style={{
        width: "160px",
        height: "120px",
        objectFit: "contain",
        background: "linear-gradient(135deg, #f0f9ff, #ffffff)",
        padding: "20px",
        borderRadius: "2px",
        filter: "grayscale(100%) opacity(0.7)",
        transition: "all 0.3s ease"
      }}
      onMouseEnter={(e) => {
        e.target.style.filter = "grayscale(0%) opacity(1)";
      }}
      onMouseLeave={(e) => {
        e.target.style.filter = "grayscale(100%) opacity(0.7)";
      }}
    />
  </div>
))}


          </div>

          {/* Modern Navigation Buttons */}
          <button
            onClick={() => scrollLeft(achievementRef)}
            style={modernButtonStyle("left")}
            onMouseEnter={(e) => {
              e.target.style.background = "#1e40af";
              e.target.style.borderColor = "#1e40af";
              e.target.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ffffff, #f8fafc)";
              e.target.style.borderColor = "#cbd5e0";
              e.target.style.color = "#2563eb";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m15 18-6-6 6-6"/>
            </svg>
          </button>
          <button
            onClick={() => scrollRight(achievementRef)}
            style={modernButtonStyle("right")}
            onMouseEnter={(e) => {
              e.target.style.background = "#1e40af";
              e.target.style.borderColor = "#1e40af";
              e.target.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ffffff, #f8fafc)";
              e.target.style.borderColor = "#cbd5e0";
              e.target.style.color = "#2563eb";
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m9 18 6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

// Modern Button Styling inspired by government websites
const modernButtonStyle = (position) => ({
  position: "absolute",
  top: "50%",
  [position]: "20px",
  transform: "translateY(-50%)",
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  color: "#2563eb",
  border: "1px solid #cbd5e0",
  padding: "0",
  cursor: "pointer",
  borderRadius: "2px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
  zIndex: 10,
  transition: "all 0.3s ease",
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

export default Tstimonialshow;